export interface Education {
  degree: string;
  university: string;
  period: string;
  bullets: string[];
}

export const education: Education[] = [
  {
    degree: "Master of Computing",
    university: "Curtin University",
    period: "Feb 2024 — Nov 2025",
    bullets: ["Major in Computer Science", "CWA: 79.27"],
  },
  {
    degree: "BSc (Hons) Engineering",
    university: "University of Moratuwa",
    period: "Nov 2017 — May 2022",
    bullets: [
      "Specialized in Computer Science and Engineering",
      "GPA : 3.55/4.20 (Second Class Upper Division)",
    ],
  },
];
